/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE_node_fetch_7c57b483__ from "node-fetch";
const searxng = (config = {})=>{
    const { baseUrl = 'https://127.0.0.1:8081' } = config;
    const search = async (query, options = {})=>{
        const { count = 10, language = 'zh-CN', categories = [
            'general'
        ], time_range, safesearch = 1 } = options;
        try {
            const params = new URLSearchParams({
                q: query,
                format: 'json',
                language,
                categories: categories.join(','),
                safesearch: safesearch.toString(),
                count: count.toString()
            });
            if (time_range) params.append('time_range', time_range);
            const response = await (0, __WEBPACK_EXTERNAL_MODULE_node_fetch_7c57b483__["default"])(`${baseUrl}/search?${params.toString()}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!response.ok) throw new Error(`SearXNG search failed with status: ${response.status}`);
            const data = await response.json();
            return {
                query,
                results: data.results.map((result)=>({
                        title: result.title || '',
                        url: result.url || '',
                        content: result.content || result.snippet || '',
                        engine: result.engine,
                        score: result.score
                    })).slice(0, count)
            };
        } catch (error) {
            console.error('SearXNG search error:', error);
            throw error;
        }
    };
    return {
        search
    };
};
export { searxng };

//# sourceMappingURL=searxng.mjs.map